export var HEADER = {};
export var APP_NAME = "New Pubdesk";
export var WIDGET_SUMMARY = "WG_SUMMARY";
export var WIDGET_COMPOSED_CHART = "WG_COMPOSED_CHART_PV";
export var WIDGET_LINE_CHART = "WG_LINE_CHART";
export var WIDGET_SIMPLE_LINE_CHART = "WG_SIMPLE_LINE_CHART";
export var WIDGET_COMPARE_LINE_CHART = "WG_COMPARISION_LINE_CHART";
export var WIDGET_TOP_3_INCREASE = "WG_TOP_THREE_INCREASE";
export var WIDGET_TOP_3_DECREASE = "WG_TOP_THREE_DECREASE";
export var WIDGET_CALENDAR = "WG_CALENDAR";
export var WIDGET_PIE_CHART = "WG_PIE_CHART";
export var WIDGET_BAR_CHART = "WG_BAR_CHART";
export var WIDGET_PUBLISHER_MEDIAN_CPM = "WG_PUBLISHER_CPM_MEDIAN";
export var WIDGET_TREND_CHART = "WG_TREND_CHART";
export var ROLE_ADMIN = "ROLE_PUBLISHER_ADMIN";
export var ROLE_OPERATOR = "ROLE_OPERATOR";
export var ROLE_SUPER_ADMIN = "ROLE_SUPERADMIN";
export var ROLE_MEDIA_BOSS = "ROLE_PUBLISHER_BOSS";
export var ROLE_MEDIA_MEMBER = "ROLE_PUBLISHER_MEMBER";
export var LEFT_DEFAULT_TEMPLATE = "LEFT_DEFAULT_TEMPLATE";
export var LEFT_USER_TEMPLATE = "LEFT_USER_TEMPLATE";
export var USER_TEMPLATE = "ACCOUNT";
export var DEFAULT_TEMPLATE = "DEFAULT";
export var LEVEL_TOTAL = "TOTAL";
export var LEVEL_PLATFORM = "PLATFORM";
export var LEVEL_PLATFORM_GROUP = "PLATFORM_GROUP";
export var LEVEL_INVENTORY = "PUBDESK_INVENTORY";
export var METRIC_DEFAULT = "DEFAULT";
export var METRIC_DATE_AND_SALE = "DATE_AND_SALE";
export var METRIC_DATA_LAYER = "DATA_LAYER";
export var METRIC_ADVERTISEMENT = "ADVERTISEMENT";
export var METRIC_ANALYTIC = "ANALYTIC";
export var METRIC_VIDEO_VIEW = "VIDEO_VIEW";
export var METRIC_TREND = "TREND";
export var PRESENTATION_TYPE_SUMMARY = "SUMMARY";
export var PRESENTATION_TYPE_TABLE = "SINGLE_TABLE";
export var PRESENTATION_TYPE_BAR = "STACKED_BAR_CHART";
export var PRESENTATION_TYPE_BAR_100 = "STACKED_BAR_CHART_100";
export var PRESENTATION_TYPE_PIE = "PIE_CHART";
export var PRESENTATION_TYPE_COMPARISION_LINE = "LINE_CHART";
export var PRESENTATION_TYPE_SIMPLE_LINE = "SIMPLE_LINE_CHART";
export var PRESENTATION_TYPE_STACKED_AREA = "STACKED_AREA_CHART";
export var PRESENTATION_TYPE_COMPOSE = "COMPOSED_CHART";
export var PRESENTATION_TYPE_MULTIPLE_LINE = "MULTIPLE_LINE_CHART";
export var VALIDATION_TYPE_EMAIL = "EMAIL";
export var VALIDATION_TYPE_TEXT = "TEXT";
export var VALIDATION_TYPE_ARRAY = "ARRAY";
export var VALIDATION_TYPE_TEXT_NOT_SPECIAL_CHARACTER = "TEXT_NOT_SPECIAL_CHARACTER";
export var WIDGET_DISPLAY_TYPE_FULL = "FULL";
export var WIDGET_DISPLAY_TYPE_HALF = "HALF";
export var WIDGET_SETTING_KEY_TITLE = "widget_title_name";
export var WIDGET_SETTING_KEY_DISPLAY_MODE = "default_display_mode";
export var WIDGET_SETTING_KEY_LEVEL_DATA = "default_level_data";
export var WIDGET_SETTING_KEY_METRIC = "default_metric_id";
export var WIDGET_SETTING_KEY_VALUE_LEVEL = "default_value_level";
export var WIDGET_SETTING_KEY_VALUE_LEVEL_1 = "default_value_level_1";
export var WIDGET_SETTING_KEY_VALUE_LEVEL_2 = "default_value_level_2";
export var WIDGET_SETTING_KEY_DEVICE = "default_device_type";
export var WIDGET_SETTING_KEY_CHART_TYPE = "default_chart_type";
export var WIDGET_SETTING_KEY_LINE_METRIC = "default_line_metric_id";
export var WIDGET_SETTING_KEY_PERIOD = "default_period";
export var WIDGET_SETTING_KEY_LINE_TYPE = "default_line_type";
export var WIDGET_SETTING_KEY_INVENTORY_FILTER = "default_inventory_filter";
export var WIDGET_SETTING_KEY_PLATFORM_GROUP_FILTER = "default_platform_group_filter";
export var WIDGET_SETTING_KEY_SUB_PLATFORM_GROUP_FILTER = "default_sub_platform_group_filter";
export var WIDGET_SETTING_KEY_PLATFORM_FILTER = "default_platform_filter";
export var WIDGET_SETTING_KEY_VALUE_FILTER_LEVEL = "default_filter_value_level";
export var WIDGET_SETTING_KEY_VALUE_PLATFORM_FILTER_LEVEL = "default_filter_value_platform_level";
export var WIDGET_SETTING_KEY_VALUE_PLATFORM_GROUP_FILTER_LEVEL = "default_filter_value_platform_group_level";
export var WIDGET_SETTING_KEY_VALUE_INVENTORY_FILTER_LEVEL = "default_filter_value_inventory_level";
export var WIDGET_SETTING_KEY_MEDIAN = "default_media_value";
export var WIDGET_SETTING_KEY_DATE_RANGE = "default_date_range_value";
export var WIDGET_SETTING_KEY_DEVICE_CATEGORY = "default_device_category";
export var WIDGET_SETTING_NAME = "setting_name";
export var WIDGET_SETTING_VALUES = "setting_values";
export var WIDGET_SETTING_TYPE = "setting_type";
export var WIDGET_SETTING_ICON = "setting_icon";
export var WIDGET_SETTING_WIDTH = "setting_width";
export var WIDGET_SETTING_ROW = "setting_row";
export var WIDGET_SETTING_VALUE = "setting_selected_values";
export var COMPONENT_TYPE_TEXT = "TEXT";
export var COMPONENT_TYPE_SELECT = "SELECT";
export var COMPONENT_TYPE_BOOLEAN = "BOOLEAN";
export var COMPONENT_TYPE_DROPDOWN = "DROPDOWN";
export var COMPONENT_TYPE_BOX = "BOX_CLICK";
export var DATA_LEVEL_PUBLISHER = "PUBLISHER";
export var DATA_LEVEL_MEDIA = "MEDIA";
export var DATA_LEVEL_INVENTORY = "INVENTORY";
export var ENABLE_SELECT_PUBLISHER = "ENABLE";
export var DISABLE_SELECT_PUBLISHER = "DISABLE";
export var VIEW_RENDER_LIST = "LIST";
export var VIEW_RENDER_CREATE = "CREATE";
export var VIEW_RENDER_EDIT = "EDIT";
//Notification
export var NOTIFICATION_SUCCESS = "NOTIFICATION_SUCCESS";
export var NOTIFICATION_INFO = "NOTIFICATION_INFO";
export var NOTIFICATION_WARN = "NOTIFICATION_WARN";
export var NOTIFICATION_ERROR = "NOTIFICATION_ERROR";
export var NOTIFICATION_DEFAULT = "NOTIFICATION_DEFAULT";
export var NOTIFICATION_DARK = "NOTIFICATION_DARK";
export var PUBLISHER_VISIBILITY_INTERNAL = "INTERNAL_USER";
export var PUBLISHER_VISIBILITY_EXTERNAL = "EXTERNAL_USER";
export var PUBLISHER_VISIBILITY_ALL = "DEFAULT_FOR_ALL";
export var PLATFORM_COLORS_BY_PUBLISHER = "platform_colors_by_publisher";
export var DEFAULT_VIEW_ACTION = "DEFAULT_VIEW";
